import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { addReservationCompleteHook } from 'checkout/actions/hooks';
import { connect } from 'react-redux';
import {toDecimals} from "@h/currency";

class TheTradeDesk extends Component {
  constructor(props) {
    super(props);
    this.props.addReservationCompleteHook(this.onReservationComplete);
  }

  render() {
    return null;
  }

  reportEvent(...args) {
    this.props.reportEvent(...args);
  }
  onReservationComplete = () => {
    this.props.reportEvent('event', {
      orderId: this.props.confirmationNumber,
      value: this.props.total?.amount !== undefined ? toDecimals({amount: this.props.total.amount, currency: this.props.currency}) : 0.00,
      currency: this.props.currency,
      td1: this.props.event.event_id, // Pro event id
      td2: this.props.slug,
      td3: this.props.sellerOrganization,
      td4: this.props.tickets?.length + this.props.productSales?.length + this.props.bundleSales?.length, // Pro quantity_total number of tickets or items
    });
  };
}

const mapStateToProps = state => {
  const firstEventEntry = Object.values(state.event.events)[0];
  return {
    total: state.reservation.total_cost,
    currency: state.reservation.currency,
    confirmationNumber: state.reservation.confirmation_number,
    tickets: state.tickets.tickets,
    productSales: state.productSales.products,
    bundleSales: state.bundleSales.bundles,
    event: firstEventEntry.event,
    sellerOrganization: firstEventEntry.seller_organization,
    slug: state.ui.listingSlug,
  }
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      addReservationCompleteHook,
    },
    dispatch,
  );
};

TheTradeDesk.propTypes = {
  config: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(TheTradeDesk)
